import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import ConditionPage from "@/pages/ConditionPage";
import ServicePage from "@/pages/ServicePage";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import Privacy from "@/pages/Privacy";
import Nutrizione from "@/pages/Nutrizione";
import NotFound from "@/pages/NotFound";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import CookieBanner from "@/components/CookieBanner";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import AnnouncementBar from "@/components/AnnouncementBar";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <AnnouncementBar />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/patologie/:slug" element={<ConditionPage />} />
          <Route path="/prestazioni/:slug" element={<ServicePage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/nutrizione" element={<Nutrizione />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <CookieBanner />
        <WhatsAppFloat />
      </BrowserRouter>
    </div>
  );
}

export default App;
